import React from 'react';
import { Space, Table, Card, Flex, Button, Form } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import InputNumber from 'components/input-number';
import ProductOptionPicker from 'components/pickers/product-option';
import AtrributePicker from './AttributePicker';
import ImagePicker from 'components/pickers/image/ImagePicker';

const Desktop = ({ viewModel, embedded = false }) => {
  const {
    id,
    form,
    options,
    productOptions,
    sortedVariants,
    filteredOptions,
    navigate,
    onFinish,
    onFinishFailed,
    loadProductOptions,
    onSelectOptionChange,
    onUpdateProductVariant,
    onVariantImageChange,
    onGroupImageChange,
    onVariantOriginalPriceChange,
    attributeChange,
    removeOption,
    setAllVariantPrice,
  } = viewModel;

  const rowSpansOpt0 = [];
  const opt0 = filteredOptions[0];

  if (opt0) {
    let i = 0;
    while (i < sortedVariants.length) {
      const val = sortedVariants[i].options?.find((o) => o.id === opt0.id)?.value;
      let count = 1;
      while (i + count < sortedVariants.length) {
        if (sortedVariants[i + count].options?.find((o) => o.id === opt0.id)?.value === val) count++;
        else break;
      }
      for (let j = 0; j < count; j++) rowSpansOpt0.push(j === 0 ? count : 0);
      i += count;
    }
  }

  const columns = [
    ...filteredOptions.map((opt, idx) => {
      if (idx === 0) {
        return {
          title: opt.title || 'Thuộc tính 1',
          onCell: (_, rowIndex) => ({ rowSpan: rowSpansOpt0[rowIndex] ?? 1 }),
          width: 250,
          render: (_, record) => {
            const variantOpt = record.options?.find((o) => o.id === opt.id);
            const optDef = productOptions.find((x) => x.id === opt.id);
            const label = optDef?.values?.find((x) => x.id === variantOpt?.value)?.title || variantOpt?.value || '-';
            return (
              <div>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>{label}</div>
                <ImagePicker value={record.image} onChange={(e) => onGroupImageChange(e, opt.id, variantOpt?.value)} />
              </div>
            );
          },
        };
      }

      return {
        title: opt.title || `Thuộc tính ${idx + 1}`,
        render: (_, record) => {
          const variantOpt = record.options?.find((o) => o.id === opt.id);
          const optDef = productOptions.find((x) => x.id === opt.id);
          return optDef?.values?.find((x) => x.id === variantOpt?.value)?.title || variantOpt?.value || '-';
        },
      };
    }),
    ...(filteredOptions.length === 0
      ? [
          {
            title: 'Hình ảnh',
            render: (_, { image, variant_id }) => <ImagePicker value={image} onChange={(e) => onVariantImageChange(e, variant_id)} />,
          },
        ]
      : []),
    {
      title: () => (
        <div>
          Giá <InputNumber onChange={(e) => setAllVariantPrice(e)} />
        </div>
      ),
      render: (_, { variant_id, original_price }) => <InputNumber value={original_price} onChange={(e) => onVariantOriginalPriceChange(e, variant_id)} />,
    },
  ];

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Card size="small" title="Biến thể" style={{ width: '100%' }}>
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            {options.map((x) => {
              if (x.id == 'default') {
                return null;
              }

              return (
                <div key={x.id}>
                  <label>{x.title}</label>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <div style={{ flexGrow: 1 }}>
                      <ProductOptionPicker value={x.values} id={x.id} onChange={onSelectOptionChange} onAddNewValue={loadProductOptions} />
                    </div>
                    <div>
                      <Button onClick={() => removeOption(x.id)} type="text">
                        <DeleteOutlined />
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </Space>

          <AtrributePicker onChange={attributeChange} value={options.map((x) => x.id)} onOptionAdded={loadProductOptions} />

          <Table pagination={false} dataSource={sortedVariants} rowKey={(row) => row?.variant_id || row?.id} columns={columns} style={{ marginTop: 16 }} />

          <div style={{ marginTop: 32 }}>
            <Flex justify="flex-end">
              <Space>
                {!embedded && (
                  <Button type="default" onClick={() => navigate(`/product/edit/${id}`)}>
                    Back
                  </Button>
                )}
                <Button type="primary" onClick={onUpdateProductVariant}>
                  Cập nhật
                </Button>
              </Space>
            </Flex>
          </div>
        </Card>
      </Space>
    </Form>
  );
};

export default Desktop;

